import { render, staticRenderFns } from "./donor_box_v2.vue?vue&type=template&id=4ce6c9a2&"
import script from "./donor_box_v2.vue?vue&type=script&lang=js&"
export * from "./donor_box_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports